import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import ClickOutside from 'react-click-outside';
import { omit } from 'lodash';
import { ApButtonIcon } from '@alixpartners/ui-components';

import { Tooltip } from 'components/Tooltip';

import { Wrapper, Label, IconWrapper, Overlay, Content } from './styles';

const IS_TOUCH = 'ontouchstart' in document.documentElement;

export class Subnav extends Component {
	static propTypes = {
		iconClass: PropTypes.func,
		iconName: PropTypes.string,
		open: PropTypes.bool,
		defaultOpen: PropTypes.bool,
		leftAlign: PropTypes.bool,
		activePathnames: PropTypes.arrayOf(PropTypes.string),
		tooltipText: PropTypes.string,
		tooltipError: PropTypes.bool,
		onChangeOpen: PropTypes.func,
		onTooltipHide: PropTypes.func,
		disabled: PropTypes.bool,
	};

	static defaultProps = {
		defaultOpen: false,
		disabled: false,
		leftAlign: false,
		activePathnames: [],
		tooltipError: false,
		onChangeOpen: () => {},
		onTooltipHide: () => {},
	};

	state = {
		open: this.props.defaultOpen,
	};

	labelNode = null;

	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	render() {
		const {
			iconClass,
			iconName,
			children,
			open = this.state.open,
			leftAlign,
			activePathnames,
			tooltipText,
			tooltipError,
			onTooltipHide,
			showOnClick,
			hideOnChildrenClick,
			...props
		} = this.props;
		const Icon = iconClass;
		const { width: labelWidth, height: labelHeight, y: labelY } = this.getRect(
			this.labelNode
		);

		const mouseMoveProps = showOnClick
			? {
					onClick: this.handleMouseEnter,
			  }
			: IS_TOUCH
				? {}
				: {
						onMouseEnter: this.handleMouseEnter,
						onMouseLeave: this.handleMouseLeave,
				  };

		return !this.props.disabled ? (
			<Wrapper
				{...omit(props, ['defaultOpen', 'onChangeOpen'])}
				open={open}
				{...mouseMoveProps}
			>
				<Route
					render={({ location }) => {
						const isActive = activePathnames.includes(location.pathname);

						return (
							<Label
								open={open}
								active={isActive}
								onClick={IS_TOUCH ? this.handleLabelClick : undefined}
								innerRef={ref => (this.labelNode = ref)}
							>
								<Tooltip
									show={!open && !!tooltipText}
									placement="bottom"
									text={tooltipText || ''}
									variant={tooltipError ? 'error' : 'success'}
									onHide={onTooltipHide}
								>
									{iconName ? (
										<ApButtonIcon theme="dark" iconName={iconName} />
									) : (
										<IconWrapper>
											<Icon width={24} height={24} />
										</IconWrapper>
									)}
								</Tooltip>
							</Label>
						);
					}}
				/>
				{open && (
					<ClickOutside onClickOutside={this.handleClickOutside}>
						<Overlay
							leftAlign={leftAlign}
							style={{
								minWidth: labelWidth,
								maxHeight: window.innerHeight - (labelY + labelHeight + 40),
							}}
						>
							<Content
								onClick={e => {
									if (hideOnChildrenClick) {
										e.stopPropagation();
										this.close();
									}
								}}
							>
								{children}
							</Content>
						</Overlay>
					</ClickOutside>
				)}
			</Wrapper>
		) : iconName ? (
			<ApButtonIcon theme="dark" iconName={iconName} disabled />
		) : (
			<IconWrapper disabled>
				<Icon width={24} height={24} />
			</IconWrapper>
		);
	}

	getRect(node) {
		return node ? node.getBoundingClientRect() : {};
	}

	handleResize = () => this.forceUpdate();

	open = () => {
		const nextOpen = true;
		this.setState({ open: nextOpen });
		this.props.onChangeOpen(nextOpen);
	};

	close = () => {
		const nextOpen = false;
		this.setState({ open: nextOpen });
		this.props.onChangeOpen(nextOpen);
	};

	handleClickOutside = () => {
		setTimeout(() => {
			if (this.state.open) this.close();
		}, 0);
	};

	handleLabelClick = () => {
		const { open = this.state.open } = this.props;
		const nextOpen = !open;
		this.setState({ open: nextOpen });
		this.props.onChangeOpen(nextOpen);
	};

	handleMouseEnter = () => this.open();

	handleMouseLeave = () => this.close();
}
